<script setup>
import { inject } from 'vue'

import { customDashboardStateInjectionKey } from '@/utils/injection-keys'

import ProgressModuleElementsView from '@/components/dashboard/custom-dashboard/modules/progress-module/ProgressModuleElementsView'
import ProgressModuleGridView from '@/components/dashboard/custom-dashboard/modules/progress-module/ProgressModuleGridView'

defineOptions({
  name: 'CustomDashboardProgressModuleContent'
})

defineProps({
  moduleData: {
    type: Object,
    required: true
  }
})

const customDashboardState = inject(customDashboardStateInjectionKey)
</script>

<template>
  <div class="cdpm-Wrapper">
    <ProgressModuleElementsView
      :elements="moduleData.elements"
      :enabled-columns="moduleData.enabledColumns"
      :module-id="moduleData.id"
      @open-columns-settings="customDashboardState.toggleModuleColumnsSettings(moduleData)"
    />

    <div class="cdpm-GridView">
      <ProgressModuleGridView :module-data />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~@/assets/styles/mixins';

.cdpm-Wrapper {
  overflow: hidden;
  display: grid;
  grid-template-columns: 464px 1fr;

  --cdpm-divider-size: 1px;
  --cdpm-divider-color: #{$grey-2-next};
  --cdpm-row-height: 80px;
  --cdpm-header-height: 54px;
}

.cdpm-GridView {
  overflow-x: auto;
  @include styled-native-scrollbar();
}
</style>
